import Api from "@/plugins/Api";
import Vue from 'vue';


// Controla o token do axios para evitar duas requisições ao mesmo tempo
import axios from 'axios'
let axiosCancelToken = null;

const baseUrl = '/constructions'

export default {
  namespaced: true,
  state: {
    items: [],
    pagination: {},
    stats: [],

  },
  mutations: {
    changeItems(stateObject, { data, ...pagination }) {
      stateObject.items = data;
      if (Object.keys(pagination).length)
        stateObject.pagination = pagination;
    },
    updateItem(stateObject, user) {
      const index = stateObject.items.findIndex(item => item.id === user.id);

      Vue.set(stateObject.items, index, user);
    },

    stats(stateObject, items) {
      stateObject.stats = items
    },

    clearState(stateObject) {
      stateObject.items = []
      stateObject.pagination = {}
    }
  },
  actions: {
    /**
     * Limpa o estado do módulo
     */
    clear({ commit }) {
      commit('clearState')
    },

    /**
     * Devolve os dados do store. Se não tiver, tenta atualizar
     */
    async all({ commit, state, dispatch }) {
      if (state.items.length === 0) {
        await dispatch('refresh')
      }

      dispatch('stats')

      return state.items;
    },


    /**
     * Força a atualização dos dados
     */
    async refresh({ commit }, query = {}) {
      try {
        // Cancela a requisição anterior se existir
        if (axiosCancelToken) axiosCancelToken.cancel()

        // Cria um novo token de cancelamento
        axiosCancelToken = axios.CancelToken.source();
        const options = { cancelToken: axiosCancelToken.token }

        let { data: { data } } = await Api.get(baseUrl, query, options);
        commit("changeItems", data);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Requisição cancelada')
        } else {
          throw error
        }
      }
    },

    async stats({ commit }) {
      try {
        const { data: { data } } = await Api.get(baseUrl + '/stats');
        commit('stats', data)

      } catch (error) {
        throw error
      }
    },

    /**
     * Atualiza um registro no store.
     * Se o registro existir, altere.
     * Se não existir, adicione.
     * Chama sort para adicionar os dados ordenados
     */
    async save({ commit, state, dispatch }, { payload, editing }) {
      try {

        let users = state.items;

        // console.log('dentro do store', { payload });


        // Editando
        if (editing) {
          // Requisição
          const { data: { data } } = await Api.put(`${baseUrl}/${payload.id}`, payload)
          // Altero somente o usuário modificado com os dados retornados da requisição
          dispatch('updateItemInList', data)
          return data

          // Novo
        } else {
          const { data: { data } } = await Api.post(baseUrl, payload)
          users.push(data)
          dispatch('updateSorted', users)
          return data;
        }

      } catch (error) {
        throw error;
      }
    },



    /**
     * Atualiza os dados de um usuário na lista de usuários
     */
    updateItemInList({ dispatch, state }, user) {
      let users = state.items;
      // Pesquisando o usuário atual no store e alterando somente ele

      users = users.map(item => {
        return item.id === user.id ? user : item
      })

      dispatch('updateSorted', users);
    },


    /**
     * Atualiza os partidos de forma ordenada pelo nome
     */
    updateSorted({ commit }, users) {
      //console.log('store/chamou sort')
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase())
          return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase())
          return 1;
        return 0;
      }

      commit('changeItems', { data: users.sort(compare) });
    },


  },

  // Retorna valores existentes no estado
  getters: {
    all(state) {
      return state.items || [];
    },
    stats(state) {
      return state.stats || [];
    },
    pagination(state) {
      return state.pagination || {};
    },
  }
};
